/**
 * Images should be stored in the `App/Images` directory and referenced using variables defined here.
 */

const icons = {
  emptySet: require('../Assets/Icons/empty.svg'),
}

export default icons
